import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

// Keep the keys in sync with STR_PROPERTY_KEYS in backend/server.js.
// websiteConnected: online booking, Stripe payments and the guest smart home (dobrereal.com).
export const STR_PROPERTIES = [
  {
    key: 'hisicapriorehu',
    name: 'Walnut Tree Cottage',
    siteName: 'Hišica pri orehu',
    bookingsText: 'bookings received from Hišica pri orehu',
    websiteConnected: true,
    color: '#7c4a1e',
    softColor: '#f6ead9'
  },
  {
    key: 'secondproperty',
    name: 'Second property',
    siteName: 'Second property',
    bookingsText: 'bookings for Second property',
    statusLabel: 'Not yet active',
    websiteConnected: false,
    color: '#0f766e',
    softColor: '#ccfbf1'
  }
];

export const getStrProperty = (key) => STR_PROPERTIES.find((property) => property.key === key) || null;

// The property of the current route, or null on the combined pages (/short-term-rentals/financials etc.).
export const useStrProperty = () => getStrProperty(useParams().propertyKey);

export const strBasePath = (property) => (property
  ? `/short-term-rentals/properties/${property.key}`
  : '/short-term-rentals');

// ?property= value for one property, or for the combined view when key is 'all'/missing.
export const strPropertyQuery = (key) => (key && key !== 'all' ? `?property=${encodeURIComponent(key)}` : '');

export const StrPropertyScope = () => (
  useStrProperty() ? <Outlet /> : <Navigate to="/short-term-rentals" replace />
);

export const PropertyBadge = ({ propertyKey }) => {
  const property = getStrProperty(propertyKey);
  if (!property) return null;
  return (
    <span style={{ display: 'inline-block', backgroundColor: property.softColor, color: property.color, padding: '3px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap' }}>
      {property.name}
    </span>
  );
};

const filterLabelStyle = { display: 'block', fontSize: '13px', color: '#475569', marginBottom: '5px', fontWeight: 600 };
const filterSelectStyle = { padding: '10px 12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', backgroundColor: 'white', minWidth: '180px', boxSizing: 'border-box' };

export const PropertyFilter = ({ value, onChange }) => (
  <div>
    <label style={filterLabelStyle}>
      Property
      <select value={value} onChange={(e) => onChange(e.target.value)} style={{ ...filterSelectStyle, display: 'block', marginTop: '5px' }}>
        <option value="all">All properties</option>
        {STR_PROPERTIES.map((property) => <option key={property.key} value={property.key}>{property.name}</option>)}
      </select>
    </label>
  </div>
);

// For new entries on the combined pages: there is no default, so nothing lands on a property by accident.
export const PropertySelect = ({ value, onChange, style }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} style={{ ...filterSelectStyle, ...style }}>
    <option value="">Select property</option>
    {STR_PROPERTIES.map((property) => <option key={property.key} value={property.key}>{property.name}</option>)}
  </select>
);
